var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.501953,
    width: 30.998,
    height: 30.998,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 9.14739C7.99951 8.51443 8.52548 8.00146 9.17444 8.00146H22.8236C23.4725 8.00146 23.9985 8.51443 23.9985 9.14739V22.8545C23.9985 23.4875 23.4725 24.0005 22.8236 24.0005H9.17444C8.52548 24.0005 7.99951 23.4875 7.99951 22.8545V9.14739ZM12.9422 21.3946V14.1701H10.5414V21.3946H12.9422ZM11.7423 13.1831C12.5792 13.1831 13.1002 12.6292 13.1002 11.9352C13.0852 11.2263 12.5802 10.6873 11.7583 10.6873C10.9363 10.6873 10.3994 11.2273 10.3994 11.9352C10.3994 12.6292 10.9203 13.1831 11.7263 13.1831H11.7423ZM16.65 21.3946V17.3599C16.65 17.1439 16.666 16.9279 16.73 16.7739C16.903 16.3429 17.2979 15.896 17.9619 15.896C18.8308 15.896 19.1778 16.5579 19.1778 17.5299V21.3946H21.5787V17.2509C21.5787 15.031 20.3947 13.9991 18.8148 13.9991C17.5409 13.9991 16.97 14.699 16.65 15.192V15.217H16.634C16.6393 15.2087 16.6446 15.2003 16.65 15.192V14.1701H14.2501C14.2801 14.848 14.2501 21.3946 14.2501 21.3946H16.65Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 15.999,
    fill: "white",
    transform: "translate(7.99951 8.00146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.344b7a8264caade26f950c3599af6e23.svg";
export { ForwardRef as ReactComponent };